import { CheckIns } from "@/features/check-in/check-ins";

export const Route = createFileRoute({
  component: CheckIns,
});
